const variants = [
  {
    props: { variant: 'pane' },
    style: {
      '& > .MuiListItemSecondaryAction-root': {
        position: 'initial',
        top: 0,
        right: 0,
        transform: 'none',
        display: 'inherit',
        '& > .MuiIconButton-root': {
          marginRight: '16px',
          '&:last-of-type': {
            marginRight: '0',
          },
        },
      },
    },
  },
];

export default variants;
